// @flow
import React from 'react';
import Slot from 'shared/editor/Slot';
import withThemeProvider from 'shared/hoc/withThemeProvider';
import type { $Slot } from '../../../types';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';

type TemplateSettings = {
  subnav_padding: boolean,
  background_image: string,
  color_theme: string,
  overlapping_menubar: boolean
}

type Props = {
  classes: Object,
  slots: $Slot[],
  templateSettings: TemplateSettings,
  widgetPresets: Array,
  path: string
}

function Homepage(props: Props) {
  const {
    slots, widgetPresets, path
  } = props;

  return (
    <div>
      <Menu>
        <Slot id="menu-bar" slots={slots} widgetPresets={widgetPresets} path={path} />
      </Menu>
      <Content>
        <Slot id="content" slots={slots} widgetPresets={widgetPresets} path={path} />
      </Content>
      <Footer>
        <Slot id="footer" slots={slots} widgetPresets={widgetPresets} path={path} />
      </Footer>
    </div>
  );
}

const Menu = styled(Box)(({ isEditor, templateSettings: t }) => ({
  width: '100%',
  // Keep height for Editor
  height: t?.overlapping_menubar && !isEditor ? '0px' : 'auto',

  // Menubar slide-in animation
  '& > div': t?.overlapping_menubar && !isEditor && {
    '& > div': {
      '& > header': {
        transform: 'translateY(-100px)',
        animation: '$slideDown 1s ease 0.5s',
        animationFillMode: 'forwards',
      },
      '& > div': {
        // Header animation "spacer"
        backgroundColor: 'transparent',
      }
    },
  },
  '@keyframes slideDown': {
    from: {
      transform: 'translateY(-100px)'
    },
    to: {
      transform: 'translateY(0px)'
    }
  }
}));

const Content = styled(Box)(({ theme, templateSettings: t }) => ({
  width: '100%',
  backgroundColor: t?.color_theme === 'DARK' ? 'black' : 'white',
  backgroundImage: t?.background_image ? `url(${t.background_image})` : null,
  backgroundPosition: 'CENTER CENTER',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  position: 'relative',
  paddingBottom: '0 !important',
  [theme.mediaQueries.minWidth('961px')]: {
    paddingBottom: t?.subnav_padding ? '116px' : '0',
  }
}));

const Footer = styled(Box)({
  width: '100%'
});

// https://github.com/webpack/webpack/issues/706
export default withThemeProvider(Homepage);
